export default __webpack_public_path__ + "static/media/ic_gabon.ef6a88d7.svg";